import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';
import CadastroFormDrawer from '../Components/CadastroFormDrawer/CadastroFormDrawer';
import './equipamentos.css';
import ListaEquipamentos from '../Components/ListaEquipamentos/listaEquipamentos';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../config/backend';

function Equipamentos() {
    const history = useHistory();
    const location = useLocation();
    const editIdFromState = location.state?.editId;

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");
        if (!resultado) history.push("/");
    };

    const [data, setData] = useState([]);
    const [descr, setDescr] = useState('');
    const [formDrawerOpen, setFormDrawerOpen] = useState(false);
    const [codEqp, setCodEqp] = useState('');
    const [nomEqp, setNomEqp] = useState('');
    const [desEqp, setDesEqp] = useState('');
    const [layEqp, setLayEqp] = useState('');
    const [sitEqp, setSitEqp] = useState('');
    const [idePro, setIdePro] = useState('');
    const [updIns, setUpdIns] = useState('I');
    const [mensagem, setMensagem] = useState('');

    const buscandoEquipamento = async (id) => {
        if (!id) return;
        verificandoToken();
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/equipamentos/espec", {
                headers: { Authorization: `${token}` },
                params: { codEqp: id }
            });
            if (response.data.length > 0) {
                const r = response.data[0];
                setUpdIns('U');
                setCodEqp(r.codeqp ?? r.CODEQP ?? '');
                setNomEqp((r.nomeqp ?? r.NOMEQP ?? '').toString());
                setDesEqp((r.deseqp ?? r.DESEQP ?? '').toString());
                setLayEqp((r.layeqp ?? r.LAYEQP ?? '').toString());
                setSitEqp((r.siteqp ?? r.SITEQP ?? '').toString());
                setIdePro((r.idepro ?? r.IDEPRO ?? '').toString());
            } else {
                setUpdIns('I');
                setCodEqp(''); setNomEqp(''); setDesEqp(''); setLayEqp(''); setSitEqp(''); setIdePro('');
            }
        } catch (e) { console.error(e); }
    };

    const limparForm = () => {
        setUpdIns('I');
        setCodEqp(''); setNomEqp(''); setDesEqp(''); setLayEqp(''); setSitEqp(''); setIdePro('');
        setMensagem('');
    };

    const inserindoEquipamento = async () => {
        if (!nomEqp.trim()) { setMensagem("Nome obrigatório!"); return; }
        if (!desEqp.trim()) { setMensagem("Descrição obrigatória!"); return; }
        if (!layEqp.trim()) { setMensagem("Layout obrigatório!"); return; }
        if (!sitEqp) { setMensagem("Situação obrigatória!"); return; }
        setMensagem('');
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            if (updIns === 'I') {
                await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/equipamentos", { nomEqp, desEqp, layEqp, sitEqp, idePro }, { headers: { Authorization: `${token}` } });
            } else {
                await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/equipamentos", { codEqp, nomEqp, desEqp, layEqp, sitEqp, idePro }, { headers: { Authorization: `${token}` } });
            }
            limparForm();
            setFormDrawerOpen(false);
            fetchData();
        } catch (e) { setMensagem('Erro ao salvar'); }
    };

    const fetchData = async () => {
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const baseUrl = ensureProtocol(localStorage.getItem("ipBackend2")) + "/equipamentos";
            const hasSearch = descr && descr.trim();
            const response = hasSearch
                ? await axios.get(baseUrl, { headers: { Authorization: `${token}` }, params: { descr: descr.trim() } })
                : await axios.get(baseUrl + "/lista", { headers: { Authorization: `${token}` } });
            const raw = Array.isArray(response.data) ? response.data : [];
            const normalized = raw.map((e) => ({
                codeqp: e.codeqp ?? e.CODEQP,
                nomeqp: e.nomeqp ?? e.NOMEQP ?? '',
                deseqp: e.deseqp ?? e.DESEQP ?? '',
                layeqp: e.layeqp ?? e.LAYEQP ?? '',
                siteqp: (e.siteqp ?? e.SITEQP ?? '').toString(),
                idepro: e.idepro ?? e.IDEPRO ?? ''
            }));
            setData(normalized);
        } catch (e) { console.error(e); setData([]); }
    };

    useEffect(() => { verificar(); fetchData(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => { if (editIdFromState) { buscandoEquipamento(editIdFromState).then(() => setFormDrawerOpen(true)); } }, [editIdFromState]);

    const handleEdit = (id) => { buscandoEquipamento(id).then(() => setFormDrawerOpen(true)); };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo cadastro-unificado">
                    <div className="page-header">
                        <h1>Equipamentos</h1>
                        <div className="toolbar flex-wrap">
                            <div className="input-group input-group-sm" style={{ maxWidth: 280 }}>
                                <input value={descr} onChange={(e) => setDescr(e.target.value)} type="text" className="form-control" placeholder="Pesquisar" />
                                <button onClick={fetchData} className="btn btn-secondary" type="button"><i className="fas fa-search" /></button>
                            </div>
                            <button type="button" className="btn btn-primary btn-sm" onClick={() => { limparForm(); setFormDrawerOpen(true); }}>
                                Novo equipamento
                            </button>
                        </div>
                    </div>
                    <CadastroFormDrawer
                        open={formDrawerOpen}
                        onClose={() => { limparForm(); setFormDrawerOpen(false); }}
                        title={updIns === 'U' ? 'Editar equipamento' : 'Novo equipamento'}
                    >
                        <div className="cadastro-form-drawer-form">
                            <div className="form-group">
                                <label>Sequência (edição)</label>
                                <input type="text" onChange={(e) => buscandoEquipamento(e.target.value)} className="form-control form-control-sm" placeholder="Código para editar" />
                            </div>
                            <div className="form-group">
                                <label>Nome</label>
                                <input value={nomEqp} onChange={(e) => setNomEqp(e.target.value)} className="form-control form-control-sm" />
                            </div>
                            <div className="form-group">
                                <label>Descrição</label>
                                <input value={desEqp} onChange={(e) => setDesEqp(e.target.value)} className="form-control form-control-sm" />
                            </div>
                            <div className="form-group">
                                <label>Identificação produto</label>
                                <input value={idePro} onChange={(e) => setIdePro(e.target.value)} className="form-control form-control-sm" />
                            </div>
                            <div className="form-group">
                                <label>Situação</label>
                                <select value={sitEqp} onChange={(e) => setSitEqp(e.target.value)} className="form-control form-control-sm">
                                    <option value="">Escolher...</option>
                                    <option value="A">Ativo</option>
                                    <option value="I">Inativo</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Layout</label>
                                <textarea value={layEqp} onChange={(e) => setLayEqp(e.target.value)} className="form-control form-control-sm" rows={4} />
                            </div>
                            {mensagem && <div className="alert alert-danger py-2 mb-2">{mensagem}</div>}
                            <div className="cadastro-form-drawer-form__actions">
                                <button onClick={() => { limparForm(); setFormDrawerOpen(false); }} type="button" className="btn btn-secondary btn-sm">Cancelar</button>
                                <button onClick={inserindoEquipamento} type="button" className="btn btn-primary btn-sm">Salvar</button>
                            </div>
                        </div>
                    </CadastroFormDrawer>
                    <ListaEquipamentos arrayEquipamentos={data} onEdit={handleEdit} />
                </div>
            </main>
        </div>
    );
}

export default Equipamentos;
